<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_v"></a><em>Contents</em></h2>
<p class="toc"><a href="#/xhtml/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/xhtml/map">Map</a></p>
<p class="toc t"><a href="#/xhtml/intro">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/chapter01" title="Link target outside of Sample"><span class="toc1">1</span> The Original Coffin Road: Kilmartin Valley</span></p>
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><span class="toc1">2</span> Towards the Shrine of a Saint: The Street of the Dead, Iona</span></p>
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="toc1">3</span> Intimations of Heaven: Jura</span></p>
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="toc1">4</span> Watching over the Churchyard: Morvern</span></p>
<p class="toc1"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="toc1">5</span> Islands of Graves: The Green Isle, Loch Shiel</span></p>
<p class="toc1"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="toc1">6</span> Death Croons and Soul Leadings: The Piper’s Cairn, Eigg</span></p>
<p class="toc1"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="toc1">7</span> Premonitions and Apparitions: Kintail</span></p>
<p class="toc1"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><span class="toc1">8</span> Wakes and Whisky: Barra</span></p>
<p class="toc1"><span href="#/xhtml/epilogue" title="Link target outside of Sample"><span class="toc1">9</span> Epilogue: Revisiting the Coffin Roads Today</span></p>
<p class="toc t"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/bib" title="Link target outside of Sample">Further Reading</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5641a60a